import { FolderId } from 'modules/domains/foldering';

import { TreeViewFolderData, TreeViewQueryResponse } from 'ui/indexPages/folders/treeView';
import { useFetchAssetsAndFoldersQuery } from './useFetchAssetsAndFoldersQuery';

/* Subfolders only: Due to the long-running queries (and timeouts) experienced when querying folders with a large number
 * ContentItems, it has been decided that we will (at least temporarily) only request Subfolders */

export const useTreeViewQuery = (folderId: FolderId): TreeViewQueryResponse => {
  const { childFolders, folderData, isLoading } = useFetchAssetsAndFoldersQuery(
    {
      folderId,
      pagination: {
        limit: 1000,
        offset: 0,
      },
    },
    { fetchPolicy: 'no-cache' },
  );
  return {
    childFolders,
    childItems: [],
    folderData: folderData as TreeViewFolderData,
    isLoading,
  };
};
